import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  Component,
} from "react";
import "./Order.css";
import {
  GoogleMap,
  LoadScript,
  MarkerF,
  Marker,
  Autocomplete,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaQuestionCircle } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { CiCirclePlus } from "react-icons/ci";
import { width } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import { StepperContainer } from "../StepperContainer";
import { useStepper } from "../../context/stepperContext";
import { StepHeader } from "../StepHeader";
import Cookies from "js-cookie";
import { FaHome } from "react-icons/fa";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { useCustomScreen, useScreenSize } from "../Utils";
import toast from "react-hot-toast";
import {
  POST_ORDER_REPORTS,
  POST_ORDER_CREDITS,
  TOKEN,
  GET_ALL_SAVED_CARD_DETAILS,
  SECRET_KEY,
  IV_KEY,
  BASEURL,
  CUSTOMERID,
  POST_PAYPAL_PAYMENT,
  GetToken,
} from "../../CONSTANTS";
const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const mapContainerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: 28.7041, // Default location (e.g., New Delhi)
  lng: 77.1025,
};

const Order = (google) => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [handleMessage, setHandleMessage] = useState(true);
  const libraries = React.useMemo(() => ["places"], []);
  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();
  const handleClose = () => {
    setHandleMessage(false);
    setSelectedPlace({});
    setShow(false);
    // localStorage.clear();
  };

  const [houseNumber, setHouseNumber] = useState("");
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();

  const handleShow = () => {
    const p = [...selPlaces];
    p.push(selectedPlace);
    setSelPlaces(removeDuplicates(p));
    setShow(true);
  };

  const initialPlace = location.state?.place;

  const [selectedPlace, setSelectedPlace] = useState({
    address: initialPlace?.address ? initialPlace?.address : "",
    street: initialPlace?.street ? initialPlace.street : "",
    city: initialPlace?.city ? initialPlace.city : "",
    state: initialPlace?.state ? initialPlace.state : "",
    country: initialPlace?.country ? initialPlace.country : "",
    postalCode: initialPlace?.postalCode ? initialPlace.postalCode : "",
    lat: initialPlace?.lat ? initialPlace?.lat : 0,
    lng: initialPlace?.lng ? initialPlace.lng : 0,
    type: "",
    price: "",
    delivery: "",
    deliveryPrice: "",
  });

  const [selPlaces, setSelPlaces] = useState([]);
  const [map, setMap] = useState(null);
  const navigate = useNavigate();
  const [defaultSel, setDefaultSel] = useState({
    lat: 37.7749,
    lng: -122.4194,
  });

  const handlePlaceChange = (autocomplete) => {
    // if(isLoaded){
    const place = autocomplete.getPlace();

    setHandleMessage(true);
    if (
      place &&
      place.geometry &&
      place.geometry.location &&
      place.address_components
    ) {
      const getComponent = (type) =>
        place.address_components.find((comp) => comp.types.includes(type))
          ?.long_name || "";

      const streetNumber = getComponent("street_number");
      const route = getComponent("route");
      const city =
        getComponent("locality") ||
        getComponent("sublocality") ||
        getComponent("administrative_area_level_2");
      const state = getComponent("administrative_area_level_1");
      const country = getComponent("country");
      const postalCode = getComponent("postal_code");
      const normalizedCountry = country?.toLowerCase().trim();

      const fullStreetAddress = `${streetNumber} ${route}`.trim();
      setSelectedPlace({
        address: place?.formatted_address || "",
        street: fullStreetAddress,
        city,
        state,
        country,
        postalCode,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        type: "",
        price: "",
        delivery: "",
        deliveryPrice: "",
      });
      map?.panTo({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
      // }
    }
  };

  const removeAddressHandler = (index) => {
    let places = [...selPlaces];
    places.splice(index, 1);
    setSelPlaces([...places]);
  };

  const loadAutocomplete = () => {
    const input = document.getElementById("autocomplete-input-map");
    const autocomplete = new window.google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: ["us", "ca", "au"] }, // 👈 restrict here
    });
    autocomplete.addListener("place_changed", () =>
      handlePlaceChange(autocomplete)
    );
  };

  const handleAddNewAddress = () => {
    setHandleMessage(false);

    setSelectedPlace({});
    setShow(false);
  };

  const clearSelectionsHandler = () => {
    let places = selPlaces;
    places = [];
    setSelPlaces([...places]);
    setShow(false);
    setHandleMessage(false);
    setSelectedPlace({});
  };

  const handleSearchClick = () => {

    const input = document.getElementById("autocomplete-input-map");
  
  
    if (input && selectedPlace) {

      map?.panTo(selectedPlace);
    }
  };

  const clearCurrentSelHandler = () => {
    // First save the *current* selected place BEFORE clearing
    const savedPlace = { ...selectedPlace };

    // Update selPlaces list
    const updatedPlaces = [...selPlaces, savedPlace];
    setSelPlaces(removeDuplicates(updatedPlaces));

    // Now clear selectedPlace
    setSelectedPlace((prev) => ({
      ...prev,
      lat: 0,
      lng: 0,
      address: "",
      street: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
      type: "",
      price: "",
      delivery: "",
      deliveryPrice: "",
    }));

    setShow(true);
  };

  const removeDuplicates = (myArr) => {
    return myArr.filter(
      (obj1, i, arr) =>
        arr.findIndex((obj2) =>
          ["address", "lat", "lng"].every((key) => obj2[key] === obj1[key])
        ) === i
    );
  };

  useEffect(() => {
    if (isGoogleMapsLoaded && window.google) {
      initializeGeocoding();
    }
  }, [isGoogleMapsLoaded]);

  const initializeGeocoding = () => {
    const selectedAddressFromCookies = Cookies.get("selectedAddress");
    const storedAddress =
      localStorage.getItem("selectedAddress") || selectedAddressFromCookies;

    if (storedAddress && window.google) {
      const parsedAddress = JSON.parse(storedAddress);

      const geoCoder = new window.google.maps.Geocoder();

      geoCoder.geocode(
        { address: parsedAddress?.address },
        (results, status) => {
          if (status === "OK" && results && results[0]) {
            const location = results[0].geometry.location;
            const addressComponents = results[0].address_components;
            const getComponent = (type) =>
              addressComponents.find((comp) => comp.types.includes(type))
                ?.long_name || "";

            const streetNumber = getComponent("street_number");
            const route = getComponent("route");
            const city =
              getComponent("locality") ||
              getComponent("sublocality") ||
              getComponent("administrative_area_level_2");
            const state = getComponent("administrative_area_level_1");
            const country = getComponent("country");
            const postalCode = getComponent("postal_code");

            const fullStreetAddress = `${streetNumber} ${route}`.trim();

            const place = {
              address: parsedAddress.address,
              street: fullStreetAddress,
              city,
              state,
              country,
              postalCode,
              lat: location.lat(),
              lng: location.lng(),
            };

            setHouseNumber(streetNumber ? streetNumber.long_name : "0");

            setSelectedPlace(place);
            // setSelPlaces([place]);
          } else {
            console.error("Geocode failed due to:", status);
            setSelectedPlace(null);
            setSelPlaces([]);
          }
        }
      );
    } else {
      // console.error(
      //   "No address found in localStorage or Google Maps API not loaded"
      // );
    }
  };

  const navigateToPurchase = () => {
    // handleNext(steps);
    localStorage.setItem("sel-places", JSON.stringify(selPlaces));
    localStorage.setItem("login-from", "Map");
    const token = GetToken();
    if (token) {
      navigate("/order/instructions");
      setSelPlaces([]);
      setSelectedPlace({
        address: "",
        lat: 0,
        lng: 0,
        type: "",
        price: "",
        delivery: "",
        deliveryPrice: "",
      });
    } else {
      navigate("/login");
    }
  };

  const onMarkerDragEnd = useCallback((e) => {
    const lat = e?.latLng?.lat();
    const lng = e?.latLng?.lng();

    const geoCoder = new window.google.maps.Geocoder();

    geoCoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results.length > 0) {
        const address = results[0]?.formatted_address;
        const addressComponents = results[0]?.address_components;

        const getComponent = (type) => {
          const component = addressComponents.find((c) =>
            c.types.includes(type)
          );
          return component ? component.long_name : "";
        };

        const street = `${getComponent("street_number")} ${getComponent(
          "route"
        )}`.trim();
        const city =
          getComponent("locality") || getComponent("sublocality") || "";
        const state = getComponent("administrative_area_level_1");
        const country = getComponent("country");
        const postalCode = getComponent("postal_code");

        const updatedPlace = {
          lat,
          lng,
          // address,
          // street,
          // city,
          // state,
          // country,
          // postalCode,
        };

        setHouseNumber(getComponent("street_number") || "0");
        setSelectedPlace((prev) => ({
          ...prev,
          ...updatedPlace,
        }));
      }
    });
  }, []);



  const homeIcon = window.google
    ? {
        url:
          "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 24 36">
          <path fill="#007BFF" d="M12 0L0 12h4v10h16V12h4z"/>
          <circle cx="12" cy="16" r="3" fill="white"/>
          <path fill="#007BFF" d="M12 36s-8-12-8-18a8 8 0 1 1 16 0c0 6-8 18-8 18z"/>
        </svg>
      `),
        scaledSize: { width: 40, height: 50 },
        anchor: { x: 20, y: 50 },
      }
    : undefined;

  const customIcon = isGoogleMapsLoaded
    ? {
        url: "/images/icons8-home-address-60.png", // Replace with actual PNG path
        scaledSize: new window.google.maps.Size(50, 50), // Size issue fix
        anchor: new window.google.maps.Point(20, 50), // Adjust position
      }
    : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section
      style={{
        height: isSmallScreen
          ? "auto"
          : isLargeScreen && isLandscape1024
          ? "auto"
          : isXlScreen
          ? "auto"
          : isMediumScreen
          ? "auto"
          : "100vh",
        marginBottom: isSmallScreen ? "2rem" : "2rem",
      }}
    >
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        onClick={(e) => e.stopPropagation()}
        centered
        scrollable
      >
        <Modal.Header
          style={{
            height: is4kScreen ? "80px" : isIpadProPortrait ? "auto" : "50px",
            background: "lightblue",
            borderRadius: "4%",
            fontFamily: "Calibri",
            textAlign: "center",
          }}
          closeButton
        >
          <div className="col-md-5"></div>
          <Modal.Title
            className=""
            style={{
              fontSize: is4kScreen
                ? "2.3rem"
                : isIpadProPortrait
                ? "1.9rem"
                : "18px",
              textAlign: "center",
            }}
          >
            Address Saved
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row"></div>
          <Form style={{ padding: "0px" }}>
            {selPlaces.length !== 0 &&
              selPlaces.map((place, placeIndex) => (
                <div key={placeIndex} className="row place-form">
                  <div className="col-md-5">
                    <div className="col-md-5" style={{ textAlign: "center" }}>
                      <b
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isIpadProPortrait
                            ? "1.6rem"
                            : "18px",
                        }}
                      >
                        Address
                      </b>
                    </div>
                    <Form.Group
                      className="mb-3 col-md-5"
                      controlId="formAddr"
                      style={{ padding: "0px", width: "100%" }}
                    >
                      <Form.Control
                        type="text"
                        className="col-md-5"
                        value={place.address}
                        style={{
                          width: "100%",
                          height: isIpadProPortrait ? "4rem" : "",
                          fontSize: isIpadProPortrait ? "1.6rem" : "",
                        }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-5">
                    <div className="col-md-5" style={{ textAlign: "center" }}>
                      <b
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isIpadProPortrait
                            ? "1.6rem"
                            : "18px",
                        }}
                      >
                        Lat/Lng
                      </b>
                    </div>
                    <Form.Group
                      className="mb-3 col-md-5"
                      controlId="formLatndLon"
                      style={{
                        paddingRight: "0px",
                        paddingLeft: "5px",
                        width: "100%",
                      }}
                    >
                      {place.lat !== "" && place.lng !== "" && (
                        <Form.Control
                          type="text"
                          style={{
                            width: "100%",
                            height: isIpadProPortrait ? "4rem" : "",
                            fontSize: isIpadProPortrait ? "1.6rem" : "",
                          }}
                          value={String(place.lat) + "," + String(place.lng)}
                        />
                      )}
                      {place.lat === "" && place.lng === "" && (
                        <Form.Control
                          type="text"
                          style={{
                            width: "100%",
                            height: isIpadProPortrait ? "4rem" : "",
                            fontSize: isIpadProPortrait ? "1.6rem" : "",
                          }}
                        />
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-md-1 d-flex justify-content-center align-items-center">
                    <span
                      className="col-md-1"
                      style={{
                        color: "red",
                        cursor: "pointer",
                        fontSize: is4kScreen
                          ? "1.8rem"
                          : isIpadProPortrait
                          ? "1.6rem"
                          : "18px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeAddressHandler(placeIndex);
                      }}
                    >
                      Delete
                    </span>
                  </div>
                </div>
              ))}
            <Button
              className="topbar-btns search-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleAddNewAddress();
              }}
              style={{
                color: "#fff",
                background: "#25acc2",
                fontSize: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "1.6rem"
                  : "18px",
              }}
            >
              <CiCirclePlus
                size={is4kScreen ? 40 : isIpadProPortrait ? 40 : 30}
              />
              Add Another Address
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer className="row">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <Button
                variant="secondary"
                onClick={clearSelectionsHandler}
                className=""
                style={{
                  fontSize: is4kScreen
                    ? "2rem"
                    : isIpadProPortrait
                    ? "1.6rem"
                    : "18px",
                }}
              >
                Start Over
              </Button>
            </div>
            <div>
              <Button
                className=" topbar-btns search-btn"
                onClick={navigateToPurchase}
                disabled={selPlaces.length === 0}
                style={{
                  fontSize: is4kScreen
                    ? "2rem"
                    : isIpadProPortrait
                    ? "1.6rem"
                    : "18px",
                }}
              >
                Next Step
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      <div
        className="container"
        style={{
          marginTop: is4kScreen
            ? "7rem"
            : isXxlScreen
            ? "-2rem"
            : isXlScreen
            ? "-1rem"
            : isIpadProPortrait
            ? "3rem"
            : isLargeScreen
            ? "-2rem"
            : "",
        }}
      >
        <div className="row order-container">
          <StepHeader
            bg1={true}
            title1="Enter Address"
            title2="Add Instructions"
            title3="Confirm Order"
          />
        </div>

        <LoadScript
          googleMapsApiKey={API_KEY}
          libraries={libraries}
          onError={() => console.error("Failed to load Google Maps API")}
          onLoad={() => setIsGoogleMapsLoaded(true)}
        >
          <div className="d-flex order-container justify-content-center align-items-center gap-3 my-3">
            <Autocomplete
              onLoad={loadAutocomplete}
              className="col-7 col-md-8 col-xs-12"
              onPlaceChanged={handlePlaceChange}
              options={{
                componentRestrictions: { country: ["us", "ca"] },
              }}
            >
              <input
                id="autocomplete-input-map"
                value={selectedPlace?.address || ""}
                onChange={(e) => {
                  setSelectedPlace({ address: e.target.value });
                }}
                type="text"
                placeholder="Search for a place"
                style={{
                  border: "2px solid lightgray",
                  marginTop: "15px",
                  width: "100%",
                  height: is4kScreen
                    ? "2.8em"
                    : isIpadProPortrait
                    ? "4rem"
                    : "3rem",
                  fontSize: is4kScreen
                    ? "2.2rem"
                    : isIpadProPortrait
                    ? "1.6rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "",
                  marginLeft: isMediumScreen ? "1rem" : "",
                }}
                className=""
              />
            </Autocomplete>

            <button
              className=" search-btn"
              style={{
                marginTop: "10px",
                height: "3em !important",
                width: "100px",
                backgroundColor: "#bae5ec",
                fontSize: is4kScreen
                  ? "1.8rem"
                  : isXxlScreen
                  ? "1.3rem"
                  : isIpadProPortrait
                  ? "1.6rem"
                  : isMediumScreen
                  ? "1.2rem"
                  : "",
                paddingLeft: is4kScreen ? "1rem" : "",
                paddingRight: is4kScreen ? "1rem" : "",
                marginLeft: isMediumScreen ? "1rem" : "",
              }}
              disabled={selectedPlace.address === "" || selectedPlace.lat === undefined || selectedPlace.lng === undefined}
              onClick={handleSearchClick}
            >
              Search
            </button>

            <span className="col-md-2"></span>
          </div>

          <div
            className="map-container bg-white"
            style={{
              flex: 1,
              height:
                isLargeScreen && isLandscape1024
                  ? "65vh"
                  : isMediumScreen
                  ? "70vh"
                  : "auto",
              marginBottom: isLargeScreen && isLandscape1024 ? "" : "2rem",
              padding: "1rem",
            }}
          >
            <div
              className={`${
                handleMessage ? "" : "hide-message"
              } p-2 responsive-row`}
              style={{
                position: "relative",
                width: "100%", // Make it occupy the full container width
                paddingBottom: isLargeScreen && "4rem",
              }}
            >
              <p
                className={`col-12 text-responsive col-md-4 d-flex align-items-center justify-content-start col-lg-${
                  isIpadProPortrait ? "6" : "4"
                } text-md-start mb-2 mb-md-0 align-items-center text-start text-md-start`}
                style={{
                  paddingLeft: isSmallScreen
                    ? "0px"
                    : isMediumScreen
                    ? "0.3rem"
                    : "2rem",
                  fontSize: is4kScreen
                    ? "2.3rem"
                    : isXxlScreen
                    ? "1.2rem"
                    : isXlScreen
                    ? "1.2rem"
                    : isIpadProPortrait
                    ? "1.6rem"
                    : isLargeScreen
                    ? "1.1rem"
                    : isMediumScreen
                    ? "1.3rem"
                    : "1rem",
                }}
              >
                Place pin on the correct structure and select:
              </p>
              <div
                className={`col-12 col-md-12 col-lg-${
                  isIpadProPortrait ? "6" : "8"
                }  d-flex justify-content-md-start justify-content-between align-items-center`}
              >
                <button
                  onClick={handleShow}
                  disabled={!selectedPlace.address && !selectedPlace?.lat || !selectedPlace?.lng}
                  style={{
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.2rem"
                      : "0.9rem",
                  }}
                  className="btn btn-primary me-2"
                >
                  That's It
                </button>
                <FaQuestionCircle
                  style={{
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.1rem"
                      : "",
                  }}
                  className="me-2"
                  title="If you are SURE the pin is making the correct structure, click 'That's It'"
                />
                <div
                  style={{
                    marginRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                  }}
                >
                  <h6
                    className="m-0"
                    style={{
                      fontSize: is4kScreen
                        ? "1.8rem"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? ""
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? "1.5rem"
                        : "",
                    }}
                  >
                    Or
                  </h6>
                </div>
                <button
                  className="btn btn-secondary me-2"
                  onClick={clearCurrentSelHandler}
                  disabled={!selectedPlace.address && !selectedPlace?.lat || !selectedPlace?.lng}
                  style={{
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.6rem"
                      : isLargeScreen
                      ? ""
                      : isMediumScreen
                      ? "1.2rem"
                      : "",
                  }}
                >
                  I'm Not Sure
                </button>
                <FaQuestionCircle
                  style={{
                    fontSize: is4kScreen
                      ? "1.8rem"
                      : isXxlScreen
                      ? ""
                      : isXlScreen
                      ? ""
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? ""
                      : "",
                  }}
                  title="If you are UNSURE the pin is making the correct structure, click 'I'm Not Sure'"
                />
              </div>
            </div>

            <div
              className="d-flex justify-content-center align-items-center m-0"
              style={{
                padding: "0px",
                marginBottom: "5rem",
              }}
            >
              <GoogleMap
                mapContainerStyle={{
                  width: "95%",
                  height: isSmallScreen
                    ? "55vh"
                    : isMediumScreen
                    ? "58vh"
                    : isLargeScreen
                    ? "50vh"
                    : isXlScreen
                    ? "50vh"
                    : isXxlScreen
                    ? "53vh"
                    : is4kScreen
                    ? "60vh"
                    : "60vh",
                  position: "relative",
                  padding: "0px",
                }}
                mapTypeId="satellite"
                options={{
                  rotateControl: false,
                  mapTypeId: "satellite",
                  mapTypeControl: false,
                  streetViewControl: false,
                  tilt: 0,
                }}
                center={
                  selectedPlace?.lat && selectedPlace?.lng
                    ? selectedPlace
                    : defaultSel
                } // Default to San Francisco
                zoom={19}
                onLoad={(map) => setMap(map)}
              >
                <MarkerF
                  position={selectedPlace}
                  icon={customIcon}
                  draggable
                    onDragEnd={onMarkerDragEnd}
                ></MarkerF>
              </GoogleMap>
            </div>
          </div>
        </LoadScript>
      </div>
    </section>
  );
};

export default Order;
